import { useQuery } from '@tanstack/react-query';

import { getMyPoints } from '@/api/gen/point-controller/point-controller.gen';
import { ZepQuizApiError } from '@/api/httpClient';
import { useUser } from '@/lib/auth';

interface MyPointHistory {
  currentBalance: number;
}

export const QUERY_KEY_MY_POINTS = 'my-points';

async function fetchMyPoints() {
  try {
    const response = await getMyPoints({ limit: 1 });
    return response.data as MyPointHistory;
  } catch (error) {
    if (error instanceof ZepQuizApiError && error.httpStatus === 404) {
      return { currentBalance: 0 };
    }
    throw error;
  }
}

/** 학생 계정의 포인트 잔액. 비학생은 enabled=false 로 호출하지 않는다. */
export const useMyPoints = () => {
  const { user } = useUser();
  return useQuery({
    queryKey: [QUERY_KEY_MY_POINTS, user?.quizUserId],
    queryFn: fetchMyPoints,
    enabled: user?.type?.toLowerCase() === 'student',
    retry: false,
    throwOnError: false,
    meta: { ignoreError: true },
  });
};
